import type { HTMLAttributes, ReactNode } from 'react';

interface FormMessageProps extends HTMLAttributes<HTMLParagraphElement> {
  tone?: 'helper' | 'error';
  children?: ReactNode;
}

export const FormMessage = ({
  tone = 'helper',
  className,
  children,
  ...props
}: FormMessageProps) => {
  if (!children) {
    return null;
  }

  return (
    <p
      className={[
        'form-message',
        `form-message--${tone}`,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role={tone === 'error' ? 'alert' : undefined}
      {...props}
    >
      {children}
    </p>
  );
};
